import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../rootState';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.auth || initialState;

export const selectAuth = createSelector([selectSlice], (state) => state);
